export const VideoPlayerConstants = {
    VIDEO_PLAYER_DEFAULT_SIZE: '100%',
    DOWNLOAD: 'download',
    NO_DOWNLOAD: 'nodownload',
    DEFAULT_PLAYER_ID: 'videoPlayer',
    VISIBLE: 'visible',
    HIDDEN: 'hidden',
    NO_REMOTE_PLAY_BACK: 'noremoteplayback',
    NO_PLAY_BACK_RATE: 'noplaybackrate'
};
//# sourceMappingURL=VideoPlayerConstants.js.map